import React from 'react';
import { IconProps } from './type';

export const ICFileInvoice: React.FC<IconProps> = ({
    height = 24,
    width = 24,
}) => {
    return (
        <svg
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            viewBox="0 0 24 24"
            height={height}
            width={width}
        >
            <path stroke="none" d="M0 0h24v24H0z" />
            <path d="M14 3v4a1 1 0 001 1h4" />
            <path d="M17 21H7a2 2 0 01-2-2V5a2 2 0 012-2h7l5 5v11a2 2 0 01-2 2zM9 7h1M9 13h6M13 17h2" />
        </svg>
    );
};
